import "./MessageDisplay.css";
import Form from "react-bootstrap/Form";
import { useRef, useState } from "react";
import InputFieldBlank from "../FormParts/InputFieldBlank";
import FormSubmitButton from "../FormParts/FormSubmitButton";
import MessageDisplay from "./MessageDisplay";
import { getRequest ,loginRequest,validateOTPRequest} from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";


const Confirmation = ({ msg, setMsg}) => {
    const [sendOtp,setSendOtp]=useState(false);
    const [newUser,setNewUser]=useState(false);
    const [validationMsg,setValidationMsg]=useState("");
    const [validationMsgType,setValidationMsgType]=useState("");
    const loginForm=useRef(null);

    const closeModule = (e) => {
        e.preventDefault();
        setMsg("");
    }
    const handleSubmit=(e)=>{
        if(sendOtp===false){
            handleSendOTP(e);
        }else if(sendOtp===true && newUser===false){
            validateOtp(e);
        }else if(sendOtp===true && newUser===true){
            updateName(e);
        }

    };
    const updateName = (e) => {
		e.preventDefault();
		// if (!validateName()) {
		// 	return;
		// }
		var displayName=loginForm.current['userDisplayName'].value;
		getRequest("api/Auth/UpdateDisplayName?newName="+displayName, UserProfile.getToken()).then(r => r.json()).then(res => { 
			if (res.status===1){
				UserProfile.setName(displayName.toString());
				setNewUser(false);
                setSendOtp(false);
				setMsg("");
    		}else{
				setValidationMsg("Not able to update name. Try again later.");
				setValidationMsgType("Error");
				return;
			}
		}).catch(err => {
			console.log(err);
		});

	};
    const handleSendOTP = (e) => {
            e.preventDefault();
            // if (!validateForm()) {
            //     return;
            // }
            var postBody = {
                ContactInfo: loginForm.current['phonePrefix'].value +loginForm.current['userPhone'].value
            };
            console.log(postBody);
            loginRequest(postBody).then(r => r.json()).then(res => {
                console.log(res);
                if (res.status !== 1)
                {
                    setValidationMsg("Not able to send OTP. Please try again later.");
                    setValidationMsgType("Error");
                    return;
                }
                if (res.userId===0) {
                    setValidationMsg("Not able to send OTP. Please try again later.");
                    setValidationMsgType("Error");
                    return;
                }
                UserProfile.setUserId(res.userId);
                UserProfile.setLoginStatus("0");
                setSendOtp(true);
            }).catch(err => {
                console.log(err);
            });
        };

    const validateOtp = (e) => {
		e.preventDefault();
		// if (!validateOTP()) {
		// 	return;
		// }
		var formBody = {
			UserId: UserProfile.getUserId(),
			OTP: loginForm.current['OTP'].value,
			DeviceId:'Web_Login'
		};
		validateOTPRequest(formBody).then(r => r.json()).then(res => { 
			if (res.token === null) {
				setValidationMsg("Invalid OTP.");
				setValidationMsgType("Error");
				return;
			}
			if (res.status !== 1)
			{
				setValidationMsg("Invalid OTP.");
				setValidationMsgType("Error");
				return;
			}
			
			UserProfile.setToken(res.token);
			UserProfile.setName(res.displayName);
			UserProfile.setPhoneNumber(res.phoneNumber);
			UserProfile.setUserId(res.userId);
            UserProfile.setLoginStatus("1");
			if(res.newUser===true){
				setNewUser(true);
			}else{
                setNewUser(false);
                setSendOtp(false);
				setMsg("");
			}
		}).catch(err => {
			console.log(err);
		});

	};

    return (
        <div className={msg && msg.length>0 ? "modalOverlay" : "modalOverlay hidden"}>
            <div className="modalContent">
                <button className="closeButton" onClick={(e) => { closeModule(e) }}>X</button>
                <div className="row">
                    <MessageDisplay msg={validationMsg} setMsg={setValidationMsg}  msgType={validationMsgType}/>
                    <div className="col-md-12">
                        <p>{msg}</p>
                    </div>
                </div>
                <div>
                    <Form ref={loginForm} onSubmit={handleSubmit} className="row" style={{textAlign:"left"}}>
                        {sendOtp===false && <>

                        <p className="col-md-12">Phone Number</p>
                        <div className="col-md-2" >
                            
                            <select className="phone-prefix form-control" style={{ width:"100%" }} name="phonePrefix">
                                <option value="+1" >+1</option>
                                <option value="+44">+44</option>
                                <option value="+91" selected={true}>+91</option>
                                <option value="+61">+61</option>
                            </select></div>
                        <div className="col-md-10">
                            <input name="userPhone" type="text" />
                            {/* <InputFieldBlank  label="Phone number" /> */}
                        </div>    
                        </>}
                        {sendOtp===true && newUser==false &&<div className="col-md-12"> <InputFieldBlank name="OTP" type="number" label="OTP" /></div>}
                        {sendOtp===true && newUser==true && <div className="col-md-12"><InputFieldBlank name="userDisplayName" type="text" label="Display name" /></div>}
                        
                        <div className="offset-md-8 col-md-4">
                            <FormSubmitButton name={sendOtp===false ?
                                "Login":(sendOtp===true && newUser==false
                                ? "Validate otp":"Update name")}/>
                        </div>

                        
                    </Form>
                    </div>
            </div>
        </div>);
};

export default Confirmation;